import {
	asset,
	DrawableRectangle,
	IAssetHandle,
	IParamHandle,
	inject,
	Layout,
	Orientation,
	param,
	ScreenOrientationService,
	SpineAnimation,
	SpineResource,
	Stretch,
	view,
} from "@spawn/core";
import { FreegameService } from "@spawn/freegames";
import { BackgroundView } from "@spawn/slot-machine";
import Color from "color";

@view
export class NrgBackgroundView extends BackgroundView {
	@asset(SpineResource) public readonly backgroundAnimations!: IAssetHandle<SpineResource>;

	@inject private readonly orientationService!: ScreenOrientationService;
	@inject private readonly freegameService!: FreegameService;

	/** Skin of the background animations. Empty: the skin has the name of the animation. */
	@param({ default: "" }) skinName!: IParamHandle<string>;

	private animations!: SpineAnimation;

	constructor(options?: { textureIndex?: number; dimValue?: number }) {
		super(options);

		this.createAnimations();

		this.subscriptions.push(
			this.orientationService.orientationChanged$.subscribe((_) => this.pickBackgroundAnimation()),
			this.freegameService.isActive$.subscribe((_) => this.pickBackgroundAnimation())
		);
	}

	private createAnimations(): void {
		this.animations = new SpineAnimation(this.backgroundAnimations());
		this.backgroundSprite.addChild(this.animations);
	}

	private pickBackgroundAnimation(): void {
		const isPortrait = this.orientationService.orientation === Orientation.Portrait;
		const isFGActive = this.freegameService.isActive;
		const animationName = isFGActive
			? isPortrait
				? "fg_idle_portrait"
				: "fg_idle_landscape"
			: isPortrait
				? "bg_idle_portrait"
				: "bg_idle_landscape";

		this.updateAnimation(animationName);
	}

	private updateAnimation(animationName: string): void {
		this.animations.stop();
		this.animations.skinName = this.skinName() || animationName;
		this.animations._pixiObject.skeleton.setSlotsToSetupPose();
		this.animations.play(animationName, true);
	}

	protected override createDimView(): void {
		const dimmer = new DrawableRectangle({
			fillColor: new Color("#331100"), // hardcoded for now because passing a param loses it's type and Spawn typechecks this in drawable rectangle :)
			layout: new Layout(Stretch.Horizontal, Stretch.Vertical),
		});
		dimmer.alpha = this.options.dimValue ?? 0;
		this.addChild(dimmer);
		this.dimmer = dimmer;
	}
}
